<template>
  <v-main class="promoter-detail-page">
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">
        <span>{{ title }}</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-container fluid class="content" v-if="promoter">
      <div class="top-summary">
        <div class="d-flex align-center">
          <div class="font-weight-bold">{{ promoterName }}</div>
        </div>
        <div class="d-flex align-center">
          <div class="text--secondary">佣金</div>
          <div class="ml-2 font-weight-bold">{{ profitRatioText }}</div>
        </div>
      </div>
      <div class="balance-summary-wrapper">
        <PromoterBalance
          v-for="balance in balanceList"
          :key="balance.currency"
          :balance="balance"
          :promoter="promoter"
          :isMerchant="true"
        ></PromoterBalance>
      </div>
      <div class="detail-action-container">
        <v-btn class="action-item mt-8 mb-4" color="primary" :width="100" @click="onCustomerDetail">推广用户</v-btn>
        <v-btn class="action-item mt-8 mb-4" color="primary" :width="100" @click="onProfitDetail">收益记录</v-btn>
        <v-btn class="action-item mt-8 mb-4" color="primary" :width="100" @click="onPayoutDetail">提现记录</v-btn>
      </div>
      <div class="detail-table">
        <v-simple-table>
          <tbody>
            <tr>
              <td>用户信息</td>
              <td>
                <router-link class="font-weight-bold" :to="customerDetailLink">{{ customerDetailText }}</router-link>
              </td>
            </tr>
            <tr>
              <td>真实姓名</td>
              <td>{{ promoter.payout_fullname }}</td>
            </tr>
            <tr>
              <td>手机号</td>
              <td>{{ promoter.payout_phone }}</td>
            </tr>
            <tr>
              <td>收款备注</td>
              <td>{{ promoter.payout_note }}</td>
            </tr>
            <tr>
              <td>收款码</td>
              <td>
                <ImagePreview :url="qrcode_url"></ImagePreview>
              </td>
            </tr>
            <tr>
              <td>通知方式</td>
              <td>{{ promoter.notifier_type }}</td>
            </tr>
            <tr>
              <td>通知地址</td>
              <td>{{ promoter.notifier_url }}</td>
            </tr>
            <tr>
              <td>创建时间</td>
              <td>{{ promoter.dt_created }}</td>
            </tr>
            <tr>
              <td>更新时间</td>
              <td>{{ promoter.dt_updated }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import ImagePreview from '@/components/ImagePreview.vue'
import PromoterBalance from '@/components/PromoterBalance.vue'
import { API } from '@/plugins/api'
import { formatProfitRatio } from '@/plugins/promoter'
import { homeStore } from '@/store/home'
import { promoterStore } from '@/store/promoter/promoter'
import _ from 'lodash'

export default {
  name: 'PromoterDetailPage',
  components: { AppbarBackIcon, ImagePreview, PromoterBalance },
  data() {
    return {}
  },
  computed: {
    customer_id() {
      return this.$route.query.id || null
    },
    promoter() {
      return promoterStore.get(this.customer_id)
    },
    title() {
      if (_.isNil(this.promoter)) {
        return '推广员'
      }
      return `推广员 ${this.promoter.customer_id}`
    },
    promoterName() {
      let fullname = this.promoter?.payout_fullname || '推广员'
      let phone = this.promoter?.payout_phone || '------'
      return fullname + ' ' + phone
    },
    profitRatioText() {
      return formatProfitRatio(this.promoter?.profit_ratio)
    },
    balanceList() {
      let balance_s = this.promoter?.balance_s || []
      if (balance_s.length <= 0) {
        balance_s.push({ currency: 'CNY' })
      }
      return balance_s
    },
    qrcode_url() {
      return API.urlForImage({
        key: this.promoter.payout_qrcode_key,
        token: this.promoter.payout_qrcode_token,
      })
    },
    customerDetailText() {
      let ret = this.customer_id
      let equityName = this.promoter?.equity_balance?.equity?.name
      if (equityName) {
        ret = equityName + ' ' + ret
      }
      return ret
    },
    customerDetailLink() {
      return {
        path: '/dash/customer-detail',
        query: {
          id: this.customer_id,
        },
      }
    },
  },
  async mounted() {
    await homeStore.doLoad()
    if (_.isNil(this.promoter?.balance_s) && !_.isNil(this.customer_id)) {
      await promoterStore.doGet({
        customer_id: this.customer_id,
        include_balance: true,
      })
    }
  },
  methods: {
    onCustomerDetail() {
      this.$router.push({
        path: '/dash/promoter-customer-list',
        query: {
          promoter_customer_id: this.customer_id,
        },
      })
    },
    onProfitDetail() {
      this.$router.push({
        path: '/dash/promoter-profit-list',
        query: {
          promoter_customer_id: this.customer_id,
        },
      })
    },
    onPayoutDetail() {
      this.$router.push({
        path: '/dash/promoter-payout-list',
        query: {
          promoter_customer_id: this.customer_id,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/common';

.top-summary {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 24px;
  padding-left: 16px;
  padding-right: 16px;
}

.balance-summary {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  .card-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;

    &:not(:last-child) {
      padding-right: 4px;
    }

    .card-count {
      font-weight: 500;
      font-size: 18px;
    }

    .card-desc {
      margin-top: 6px;
      color: #666;
      font-size: 14px;
    }

    .withdraw-button {
      color: rgb(255, 86, 86);
      text-align: center;
    }
  }
}

.detail-action-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
}

.detail-table {
  tr > td:first-child {
    text-wrap: nowrap;
  }
}
</style>
